import moment from 'moment';

export default class CategoryNameChanges {
  constructor(source) {
    Object.assign(this, source || {
      new_name: '',
      by_user: '',
      updated_at: null,
    });

    this.updated_at = this.updated_at ? moment(this.updated_at) : null;
  }
}
